import { useEffect, useRef } from "react";

import type Konva from "konva";

import { KONVA_SHAPES } from "../constants";
import { MarkupMode } from "../types";

/**
 * Custom hook to manage transformer for selected annotations
 * Preserves exact logic from original implementation
 */
export const useTransformer = (
  layerRef: React.RefObject<Konva.Layer | null>,
  selectedId: string | null,
  isAnnotating: boolean,
  markupMode: MarkupMode,
) => {
  const transformerRef = useRef<Konva.Transformer>(null);

  // Update transformer when selection changes
  useEffect(() => {
    if (!transformerRef.current || !layerRef.current) return;

    if (selectedId && isAnnotating && markupMode === MarkupMode.Selection) {
      // Find the selected node - look for the box rectangle element
      const selectedNode = layerRef.current.findOne(`#${selectedId}`);
      // Only attach transformer to box rectangles (not points)
      // Check if it has the box-rect name attribute
      if (selectedNode && selectedNode.hasName && selectedNode.hasName(KONVA_SHAPES.BOX_RECT)) {
        transformerRef.current.nodes([selectedNode]);
        transformerRef.current.getLayer()?.batchDraw();
      } else {
        transformerRef.current.nodes([]);
      }
    } else {
      transformerRef.current.nodes([]);
    }
  }, [selectedId, isAnnotating, markupMode, layerRef]);

  return transformerRef;
};
